import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useJoyride } from 'react-joyride'
import { useTranslation } from 'react-i18next'
import { USER_SET_HIDE_START_REQUEST_GUIDE } from '../redux/types/user'

// ? Handling Tour for
export const useStartRequestGuide = (username) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { hideStartRequestGuide } = useSelector((state) => state.user)
  const [isHideChecked, setIsHideChecked] = useState(Boolean(hideStartRequestGuide))

  useEffect(() => {
    setIsHideChecked(Boolean(hideStartRequestGuide))
  }, [hideStartRequestGuide])

  const CustomTooltip = ({
    step,
    tooltipProps,
    primaryProps,
    skipProps,
    backProps,
    closeProps,
    index,
    size,
    isLastStep,
    controls,
  }) => {
    const handleHideToggle = (event) => {
      const checked = event.target.checked

      setIsHideChecked(checked)
      dispatch({ type: USER_SET_HIDE_START_REQUEST_GUIDE, payload: checked })
    }

    return (
      <div
        {...tooltipProps}
        style={{
          background: '#fff',
          borderRadius: '14px',
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.18)',
          padding: '18px 20px',
          maxWidth: '320px',
          color: '#1f2937',
          fontFamily: 'inherit',
        }}
      >
        <button
          {...closeProps}
          style={{
            border: 'none',
            background: 'transparent',
            color: '#6b7280',
            cursor: 'pointer',
            float: 'right',
            fontSize: '18px',
            padding: 0,
          }}
          aria-label="Close"
        >
          ×
        </button>

        <div style={{ marginRight: '20px' }}>
          <p style={{ margin: '0 0 10px', fontSize: '15px', lineHeight: 1.5 }}>
            {step.content}
          </p>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
            <input
              id="hide-tour-for-session"
              type="checkbox"
              onChange={handleHideToggle}
            />
            <label htmlFor="hide-tour-for-session" style={{ fontSize: '13px', color: '#4b5563', cursor: 'pointer' }}>
              {t('tourGuide.hideForSession')}
            </label>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', gap: '8px' }}>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {index + 1}/{size}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            {index > 0 && (
              <button {...backProps} style={{ border: '1px solid #d1d5db', borderRadius: '8px', padding: '7px 10px', background: '#fff', cursor: 'pointer' }}>
                {t('tourGuide.back')}
              </button>
            )}
            <button 
              {...skipProps} 
              style={{ border: '1px solid #d1d5db', borderRadius: '8px', padding: '7px 10px', background: '#fff', cursor: 'pointer' }}
              onClick={(e) => {
                const key = 'homepageTourDismissed_' + username
                const checkbox = document.getElementById('hide-tour-for-session')
                const checked = checkbox.checked
                localStorage.setItem(key, checked || false)
                setTimeout(() => {
                  skipProps.onClick(e)
                }, 300);
              }}    
            >
              {t('tourGuide.skip')}
            </button>
            <button 
              {...primaryProps} 
              style={{ border: 'none', borderRadius: '8px', padding: '7px 10px', background: '#2563eb', color: '#fff', cursor:     'pointer' }}
              onClick={(e) => {
                const key = 'homepageTourDismissed_' + username
                const checkbox = document.getElementById('hide-tour-for-session')
                const checked = checkbox.checked
                localStorage.setItem(key, checked || false)
                setTimeout(() => {
                  primaryProps.onClick(e)
                }, 300);
              }}
            >
              {isLastStep ? t('tourGuide.last') : t('tourGuide.next')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  const steps = [
    {
      content: t('homepage.guideStart'),
      target: '#startButton',
      tooltipComponent: (props) => <CustomTooltip {...props} controls={controls} />,
    },
  ]

  const { controls, Tour } = useJoyride({
    continuous: true,
    run: false,
    steps,
    options: {
      skipBeacon: true,
    },
    locale: {
      last: t('tourGuide.last'),
    },
  })


	// ? Logic for remembering previously dismissed tour
  const key = 'homepageTourDismissed_' + username
	const isTourDismissed = localStorage.getItem(key)
  useEffect(() => {
    if (typeof window === 'undefined') return

    const timer = window.setTimeout(() => {
      controls.start()
    }, 1500)

    return () => window.clearTimeout(timer)
  }, [controls])

  return {
    Tour,
    isTourDismissed
  }
}
